import StudentDetails from './StudentDetails.jsx';
export default StudentDetails;